export type PlaybackSessionData = {
    previousAssetId?: number;
    playbackSource?: string;
    wasViewed?: boolean;
};

export default {} as Partial<Record<string, PlaybackSessionData>>;
